import * as React from 'react';

type Props = {
  height: string;
  width: string;
  fill: string;
};

const CheckFilled = (props: Props) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 400 400"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <g>
        <g>
          <path
            d="M400,0H0V400H400zM343.083,151.083L193.749,300.416c-4.011,4.011-9.429,6.251-15.083,6.251c-0.491,0-1.003-0.021-1.515-0.043c-6.165-0.448-11.84-3.541-15.552-8.491l-64-85.333c-7.083-9.429-5.163-22.805,4.267-29.867c9.429-7.083,22.805-5.163,29.867,4.267l49.237,65.664l131.947-131.947c8.341-8.341,21.824-8.341,30.165,0C351.424,140.259,351.424,142.741,343.083,151.083z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default CheckFilled;
